var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlightlyDissatisfied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 0-16 0 8 8 0 1 0 16 0m2 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-6.5-4a1.5 1.5 0 1 1 0 3A1.5 1.5 0 0 1 12 7.5 1.54 1.54 0 0 1 13.5 6M8 7.5a1.5 1.5 0 1 1-3 0A1.5 1.5 0 0 1 6.5 6 1.54 1.54 0 0 1 8 7.5m2 4.5c1.595-.042 3.127.62 4.19 1.81l-1.42 1.42A3.24 3.24 0 0 0 10 14a3.24 3.24 0 0 0-2.77 1.23l-1.42-1.42C6.873 12.62 8.405 11.958 10 12z",
    fill: "#ef9350"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightlyDissatisfied);
export default __webpack_public_path__ + "static/media/slightly_dissatisfied.07fff180.svg";
export { ForwardRef as ReactComponent };